import { useLayoutEffect, useState } from 'react';

export default function NavGlassIndicator({ navElement, pathname }) {
  const [bounds, setBounds] = useState(null);

  useLayoutEffect(() => {
    const nav = navElement;
    if (!nav) return undefined;

    const links = Array.from(nav.querySelectorAll('a'));
    const update = () => {
      const target = nav.querySelector('a[aria-current="page"]');

      if (!target || !nav.offsetWidth) {
        setBounds(null);
        return;
      }

      const next = {
        x: target.offsetLeft,
        y: target.offsetTop,
        width: target.offsetWidth,
        height: target.offsetHeight,
      };
      setBounds((previous) =>
        previous && Object.keys(next).every((key) => previous[key] === next[key]) ? previous : next,
      );
    };

    update();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(update);
    if (observer) {
      observer.observe(nav);
      links.forEach((link) => observer.observe(link));
    }
    window.addEventListener('resize', update);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', update);
    };
  }, [navElement, pathname]);

  if (!bounds) return null;

  return (
    <span
      className="site-nav__lens"
      aria-hidden="true"
      style={{
        width: bounds.width,
        height: bounds.height,
        transform: `translate3d(${bounds.x}px, ${bounds.y}px, 0)`,
      }}
    />
  );
}
